import { api } from "../api/Middleware";
import { INTEGRATIONS_URL, SETUP_GOOGLE_CALENDAR_INTEGRATION_URL, REMOVE_GOOGLE_CALENDAR_INTEGRATION_URL } from "../api/Urls";


export const ListAllIntegrations = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const url = queryParams.toString() ? `${INTEGRATIONS_URL}?${queryParams}` : INTEGRATIONS_URL;
    
    const response = await api.get(url);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

export const GetIntegrationById = async (integrationId) => {
  try {
    const response = await api.get(`${INTEGRATIONS_URL}${integrationId}/`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

export const DeleteIntegration = async (integrationId) => {
  try {
    const response = await api.delete(`${INTEGRATIONS_URL}${integrationId}/`);
    if (response.status === 204) {
      return true;
    }
  } catch (error) {
    throw error;
  }
};

export const UpdateIntegration = async (integrationId, payload) => {
  try {
    const response = await api.put(`${INTEGRATIONS_URL}${integrationId}/`, payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

export const SetupGoogleCalendarIntegration = async (agentId, payload) => {
  try {
    const response = await api.post(SETUP_GOOGLE_CALENDAR_INTEGRATION_URL(agentId), payload);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};

export const RemoveGoogleCalendarIntegration = async (agentId) => {
  try {
    const response = await api.delete(REMOVE_GOOGLE_CALENDAR_INTEGRATION_URL(agentId));
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
};